import { CardFaceData, TemplateData } from '../../global-types';
import { FaceValidationResult, getFaceValidationResult } from './get-face-validation-result';

/**
 * Evaluate each card face against its template and return a structured result per face.
 *
 * This function is non-throwing. Callers can inspect the returned results to log
 * or react to recoverable states (e.g. `FaceValidationStatus.TemplateEvolved`) without
 * interrupting the user's editing flow.
 *
 * Faces that already have `originalCanvasJson` (previously saved projects that will
 * hydrate from the stored JSON) or that do not have a matching template face are
 * skipped and not included in the results.
 *
 * @param cardFacesList - the current list of card faces
 * @param templateData - the current template data (may reflect a newer template version
 *                       than the one the project was saved against)
 * @returns array of validation results, one entry per evaluated face
 */
export const validateCardFacesAreNotEmpty = (
  cardFacesList: CardFaceData[],
  templateData: TemplateData,
): FaceValidationResult[] => {
  const results: FaceValidationResult[] = [];

  cardFacesList.forEach((face) => {
    if (face.originalCanvasJson) {
      return;
    }
    const templateCardFace = templateData?.Faces.find(
      (currentTemplateCardFace) => currentTemplateCardFace.FaceId === face.faceId,
    );
    if (!templateCardFace) {
      return;
    }
    results.push(getFaceValidationResult(face, templateCardFace));
  });

  return results;
};
